import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import {
  fetchTematicas,
  createTematica,
  updateTematica,
} from "../../../API/apiTematicaService";
import { Tematica } from "../../../types/acao";
import styles from "./ConfigPages.module.css";

const TematicasConfigPage: React.FC = () => {
  const [tematicas, setTematicas] = useState<Tematica[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [novaTematica, setNovaTematica] = useState("");
  //const [ultimoAno, setUltimoAno] = useState<number | "">("");

  useEffect(() => {
    carregarDados();
  }, []);

  const carregarDados = async () => {
    setLoading(true);
    try {
      const tematicasData = await fetchTematicas();
      setTematicas(tematicasData);
    } catch (error) {
      console.error("Erro ao carregar temáticas:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCriarTematica = async () => {
    if (!novaTematica.trim()) {
      alert("O nome da temática não pode estar vazio!");
      return;
    }

    try {
      const anoAtual = new Date().getFullYear();
      console.log(anoAtual);
      await createTematica(novaTematica.trim(), true, anoAtual);
      setNovaTematica("");
      //setUltimoAno("");
      carregarDados();
    } catch (error) {
      console.error("Erro ao criar temática:", error);
    }
  };

  const handleToggleAtivo = async (tematica: Tematica) => {
    try {
      const novoStatus = !tematica.ativo;
      const anoAtual = new Date().getFullYear();

      await updateTematica(tematica.id, {
        nome: tematica.nome, // Enviar nome corretamente
        ativo: novoStatus,
        ultimo_ano_ativado: novoStatus ? anoAtual : tematica.ultimo_ano_ativado,
      });

      carregarDados();
    } catch (error) {
      console.error("Erro ao atualizar temática:", error);
    }
  };

  return (
    <Card className={styles.card}>
      <CardContent>
        <Typography variant="h5">Gerenciar Temáticas</Typography>

        <div
          className={styles.formGroup}
          style={{ display: "flex", gap: "10px", alignItems: "center" }}
        >
          <TextField
            label="Nova Temática"
            value={novaTematica}
            onChange={(e) => setNovaTematica(e.target.value)}
            className={styles.input}
          />
          <Button
            variant="contained"
            color="primary"
            className={styles.createButton}
            onClick={handleCriarTematica}
            disabled={!novaTematica.trim()} // Evita clique com nome vazio
          >
            Criar Temática
          </Button>
        </div>

        {loading ? (
          <CircularProgress className={styles.loading} />
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Nome</TableCell>
                  <TableCell>Ativo</TableCell>
                  <TableCell>Último Ano Ativado</TableCell>
                  <TableCell>Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tematicas.map((t) => (
                  <TableRow key={t.id}>
                    <TableCell>{t.nome}</TableCell>
                    <TableCell>{t.ativo ? "Ativa" : "Inativa"}</TableCell>
                    <TableCell>{t.ultimo_ano_ativado ?? "N/A"}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        className={`${styles.actionButton} ${t.ativo ? styles.deactivateButton : styles.activateButton}`}
                        onClick={() => handleToggleAtivo(t)}
                      >
                        {t.ativo ? "Desativar" : "Ativar"}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>
    </Card>
  );
};

export default TematicasConfigPage;
